import Modal from '@/common/Modal';
import clubStyles from '../Club.module.scss';
import styles from './DeleteSetModal.module.scss';
import { TourBagIronSet } from '@/api/models';

interface IDeleteSetProps {
  showDeleteSet: boolean;
  closeDeleteSet: () => void;
  set: TourBagIronSet;

  onDeleteSet: () => void;
}

function DeleteSetModal({ showDeleteSet, closeDeleteSet, set, onDeleteSet }: IDeleteSetProps) {
  const hasClubs = Boolean(set.tourBagIronDetails.length);
  return (
    <Modal isOpen={showDeleteSet} onClose={closeDeleteSet} className={styles.modal}>
      <div className={styles.container}>
        <div className={styles.title}>Delete Set</div>
        <div className={`${styles.subtitle} ${!hasClubs ? styles.enabled : ''}`}>Set Name: {set.tourBagIronSetName}</div>
        {hasClubs && <span className={clubStyles.errors}>Please remove any Irons from the set before deleting it.</span>}
        <div className={styles.buttons}>
          <button onClick={closeDeleteSet}>Cancel</button>
          <button onClick={onDeleteSet} disabled={hasClubs} className={`${hasClubs ? styles.disabled : ''}`}>
            Delete Set
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteSetModal;
